"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHoverWithTransition = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _useToggle5 = _interopRequireDefault(require("react-use/lib/useToggle"));
var useHoverWithTransition = function useHoverWithTransition(isInitialVisible) {
  var _useToggle = (0, _useToggle5["default"])(isInitialVisible),
    _useToggle2 = (0, _slicedToArray2["default"])(_useToggle, 2),
    isVisible = _useToggle2[0],
    setVisibility = _useToggle2[1];
  var _useToggle3 = (0, _useToggle5["default"])(false),
    _useToggle4 = (0, _slicedToArray2["default"])(_useToggle3, 2),
    isTransitionActive = _useToggle4[0],
    setTransitionActive = _useToggle4[1];
  var handleMouseEnterComponent = (0, _react.useCallback)(function () {
    if (!isInitialVisible) {
      setVisibility(true);
      setTransitionActive(true);
    }
  }, [isInitialVisible, setVisibility, setTransitionActive]);
  var handleMouseLeaveComponent = (0, _react.useCallback)(function () {
    if (!isInitialVisible) {
      setVisibility(false);
      setTransitionActive(true);
    }
  }, [isInitialVisible, setVisibility, setTransitionActive]);
  var handleTransitionEnd = (0, _react.useCallback)(function () {
    setTransitionActive(false);
  }, [setTransitionActive]);
  return {
    onMouseEnter: handleMouseEnterComponent,
    onMouseLeave: handleMouseLeaveComponent,
    onTransitionEnd: handleTransitionEnd,
    isVisible: isVisible,
    isTransitionActive: isTransitionActive,
    setVisibility: setVisibility
  };
};
exports.useHoverWithTransition = useHoverWithTransition;